import React from "react";

import "../styles/util.css";
/* MENSAJE USADO EN EL MODAL */
function Mensaje({tipo}) {
  
  return (
    <>       
       {
         tipo === 1 && (
          <div className="p-4 bcg-color mt-5 mb-5 border-rad-10">
            <section className="txt-left li-noIcon ">
              <span className="txt-bold">
                Contribuyentes de Convenio Multilateral:
              </span>{" "}
              los coeficientes se obtienen de las DDJJ Mensuales (CM03) en base a
              los Coeficientes Unificados o al Impuesto determinado para cada
              Jurisdicción, recalculado en función de las Jurisdicciones adheridas
              al Sistema SIRCREB, SIRCUPA o SIRTAC, según corresponda. Estos coeficientes
              deberán ser aplicados a los montos totales retenidos por los
              Agentes, para luego ser deducidos en la DDJJ Mensual del anticipo
              correspondiente al mes en que fueron realizadas, en el item
              "Recaudaciones Bancarias" (para SIRCREB y SIRCUPA), o en el ítem "Retenciones" (para SIRTAC), del sistema SIFERE WEB.
            </section>
          </div>
       )}
       { tipo === 0 && (
            <div>
              <section className="txt-left li-noIcon mt-3">
                <span className="txt-bold">Contribuyentes Locales:</span> su
                coeficiente será siempre 1,0000 para la jurisdicción a la cual
                pertenece, lo que implica que deberá deducirse la totalidad de la
                retención a través del aplicativo con el cual confecciona
                habitualmente su DDJJ Mensual o Bimestral.
              </section>
            </div>
       )
      }
    </>
  );
}

export default Mensaje;
